import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LoginLayout from 'layouts/LoginLayout';
import { Row, Col, Input, Card, Form, Button, message, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { handleApiSuccess, handleApiError } from 'utils';
import { usersLoginService } from 'services/user';
import LoginLogo from 'components/LoginLogo';
import Auth from 'auth';

const _auth = Auth;

function Login(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [hasExternalToken, setHasExternalToken] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const handleLogin = useCallback(
    (email, password, externalToken) => {
      setIsLoading(true);
      usersLoginService(email, password, externalToken)
        .then((response) => {
          _auth.authenticate(response.data.token, function () {
            setIsLoading(false);
            handleApiSuccess(response);
            const from = location.state?.from;
            const target = from?.pathname
              ? `${from.pathname}${from.search || ''}${from.hash || ''}`
              : '/';
            if (!response.data.legalAccepted) {
              if (target && target !== '/' && target !== '/accept-terms') {
                sessionStorage.setItem('postLegalRedirect', target);
              }
              window.location.href = '/accept-terms';
              return;
            }
            window.location.href = target;
          });
        })
        .catch((error) => {
          setIsLoading(false);
          handleApiError(error);
          if (externalToken) {
            // Remove token from URL for security
            history.replace('/login');
          }
        });
    },
    [history, location],
  );

  useEffect(() => {
    // Check for external token in URL
    const params = new URLSearchParams(location.search);
    const externalToken = params.get('externalToken');

    if (externalToken) {
      setHasExternalToken(true);
      handleLogin(null, null, externalToken);
    }
  }, [handleLogin, location]);

  const onFinish = (values) => {
    handleLogin(values.email, values.password);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const renderLoginForm = () => (
    <Card className="ant-card">
      <div className="mainicon">
        <UserOutlined />
      </div>
      <h2>Account Login</h2>
      <Form
        className="login-form"
        name="loginForm"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: 'Please input your login email!',
            },
          ]}
        >
          <Input
            size="large"
            prefix={<UserOutlined style={{ fontSize: 13 }} />}
            placeholder="Email ID"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input
            size="large"
            prefix={<LockOutlined style={{ fontSize: 13 }} />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item>
          <Button
            shape="round"
            size="large"
            type="primary"
            htmlType="submit"
            loading={isLoading}
            style={{ width: '100%' }}
          >
            Log in
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );

  return (
    <LoginLayout>
      <Row style={{ display: 'flex', flexWrap: 'nowrap', position: 'relative' }}>
        <Col xs={24} style={{ flex: '0 0 70%', maxWidth: '70%' }} className="loginLeftside">
          {process.env.REACT_APP_THEME !== 'NETWORK_COMMANDER' && <LoginLogo />}
        </Col>
        <Col xs={24} style={{ flex: '0 0 30%', maxWidth: '30%' }} className="loginRightside">
          <div>
            {hasExternalToken ? (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
                <div style={{ marginTop: '20px' }}>Logging in...</div>
              </div>
            ) : (
              renderLoginForm()
            )}
          </div>
        </Col>
      </Row>
    </LoginLayout>
  );
}

export default Login;
